import Organizadores from "../Organizadores/js/App";

export default function Organizadores() {
    return <Organizadores />
}